/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_SubmitInputs */

const id_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim Ulasan`)
};

const ms_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar Ulasan`)
};

const da_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indsend Anmeldelse`)
};

const de_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung einreichen`)
};

const en_us2_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Review`)
};

const es_es2_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar reseña`)
};

const es_mx2_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar reseña`)
};

const fil_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isumite ang Review`)
};

const fr_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumettre l'avis`)
};

const it_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia recensione`)
};

const hu_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értékelés elküldése`)
};

const nl_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review indienen`)
};

const no_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send omtale`)
};

const pl_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij recenzję`)
};

const pt_br2_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Review`)
};

const pt_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar avaliação`)
};

const ro_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trimite recenzia`)
};

const fi_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetä arvostelu`)
};

const sv_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka recension`)
};

const vi_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi đánh giá`)
};

const tr_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorumu Gönder`)
};

const cs_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat recenzi`)
};

const bg_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изпращане на ревю`)
};

const ru_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить обзор`)
};

const uk_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Надіслати відгук`)
};

const ar_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال المراجعة`)
};

const hi_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा सबमिट करें`)
};

const th_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งรีวิว`)
};

const ja_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビューを送信`)
};

const zh_cn2_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Review`)
};

const zh_hant1_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Review`)
};

const ko_forms_review_submit = /** @type {(inputs: Forms_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Review`)
};

/**
* | output |
* | --- |
* | "Submit Review" |
*
* @param {Forms_Review_SubmitInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_submit = /** @type {((inputs?: Forms_Review_SubmitInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_SubmitInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_submit(inputs)
	if (locale === "ms") return ms_forms_review_submit(inputs)
	if (locale === "da") return da_forms_review_submit(inputs)
	if (locale === "de") return de_forms_review_submit(inputs)
	if (locale === "en-US") return en_us2_forms_review_submit(inputs)
	if (locale === "es-ES") return es_es2_forms_review_submit(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_submit(inputs)
	if (locale === "fil") return fil_forms_review_submit(inputs)
	if (locale === "fr") return fr_forms_review_submit(inputs)
	if (locale === "it") return it_forms_review_submit(inputs)
	if (locale === "hu") return hu_forms_review_submit(inputs)
	if (locale === "nl") return nl_forms_review_submit(inputs)
	if (locale === "no") return no_forms_review_submit(inputs)
	if (locale === "pl") return pl_forms_review_submit(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_submit(inputs)
	if (locale === "pt") return pt_forms_review_submit(inputs)
	if (locale === "ro") return ro_forms_review_submit(inputs)
	if (locale === "fi") return fi_forms_review_submit(inputs)
	if (locale === "sv") return sv_forms_review_submit(inputs)
	if (locale === "vi") return vi_forms_review_submit(inputs)
	if (locale === "tr") return tr_forms_review_submit(inputs)
	if (locale === "cs") return cs_forms_review_submit(inputs)
	if (locale === "bg") return bg_forms_review_submit(inputs)
	if (locale === "ru") return ru_forms_review_submit(inputs)
	if (locale === "uk") return uk_forms_review_submit(inputs)
	if (locale === "ar") return ar_forms_review_submit(inputs)
	if (locale === "hi") return hi_forms_review_submit(inputs)
	if (locale === "th") return th_forms_review_submit(inputs)
	if (locale === "ja") return ja_forms_review_submit(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_submit(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_submit(inputs)
	return ko_forms_review_submit(inputs)
});
export { forms_review_submit as "forms.review.submit" }